import React from 'react';
import ComingSoon from 'components/ComingSoon';

export const TokenizeAndTrace = () => (
  <ComingSoon text="Tokenize RWAs (Real-World Assets) on the secure net zero FCEchain blockchain and ensure the traceability and safety of your products across the supply chain." />
);
